const o=" > ",t=10;export{t as DEFAULT_ALGOLIA_HIERARCHICAL_FILTER_LIMIT,o as DEFAULT_ALGOLIA_HIERARCHY_DIVIDER};
